import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  POST: 'LOGIN_POST',
  POST_SUCCESS: 'LOGIN_POST_SUCCESS',
  POST_FAILURE: 'LOGIN_POST_FAILURE',
};

export const post = actions.post(() => `${BASE_URL}/login/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});
